import { IconButton } from "@kds-web/icon-button";
import { ArrowLeftIcon, ArrowRightIcon } from "@kds-web/icons";
import { useState } from "react";
import type { JSX } from "react/jsx-runtime";
import { LinkButton } from "../../../common/LinkButton";
import AdGalleryModal from "./AdGalleryModal.tsx";

type Props = {
  openPreviousPage: () => void;
  openNextPage: () => void;
  numPages: number;
  originForTracking: string;
};

function AdGalleryHeader({
  openPreviousPage,
  openNextPage,
  numPages,
  originForTracking,
}: Props): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <header className="mb-small flex min-h-xlarge items-center justify-between text-onSurface">
      <h2 className="m-none text-title4">Galerie</h2>
      <div className="flex items-center gap-xsmall">
        <LinkButton
          onClick={(): void => setIsModalOpen(true)}
          label="Anzeige hier platzieren"
          data-gaevent={`${originForTracking},OrderOptionDetails,GALLERY`}
          data-gaevent-direct="true"
        />
        <AdGalleryModal
          isOpen={isModalOpen}
          onClose={(): void => setIsModalOpen(false)}
        />
        {numPages > 1 && (
          <>
            <IconButton
              onClick={openPreviousPage}
              icon={<ArrowLeftIcon />}
              label="zurück"
              size="small"
              variant="secondary"
            />
            <IconButton
              onClick={openNextPage}
              icon={<ArrowRightIcon />}
              label="weiter"
              size="small"
              variant="secondary"
            />
          </>
        )}
      </div>
    </header>
  );
}

export default AdGalleryHeader;
